export default {
	BASE_URL_API_AXIOS: window.location.origin + process.env.VUE_APP_BASE_URL_API_SUFFIX,
	BASE_URL_API: process.env.VUE_APP_BASE_URL_API,
	BASE_URL_API_SUFFIX: process.env.VUE_APP_BASE_URL_API_SUFFIX,
	URL_LOGIN_AZURE_AD: process.env.VUE_APP_BASE_URL_API + process.env.VUE_APP_BASE_URL_API_SUFFIX + process.env.VUE_APP_URL_SUFFIX_AZURE_AD,
	URL_PLANEJADOR: process.env.VUE_APP_URL_PLANEJADOR,
	URL_RECEPTOR: process.env.VUE_APP_URL_RECEPTOR,
};
